export default "__VITE_ASSET__CVPN1UDA__"